import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { IBus, IBusLocation } from "@/domain/entities/lineInfo";
import { BusStopEventCode } from "@/types";
import { computed, PropType } from "vue";

import MultiBusIndicator from "../main/MultiBusIndicator.vue";
import { IBusStop } from "@/domain/entities/busStop";
import BusLocationIndicatorBubble from "./BusLocationIndicatorBubble.vue";


const __default__ = {
  name: "BusLocationIndicator",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  showInMainCard: {
    type: Boolean,
    default: false,
  },
  allBusesMap: {
    type: Object as PropType<Map<string, IBus>>,
  },
  selectedBus: {
    type: Object as PropType<IBusLocation>,
  },
  busStopEventCode: {
    type: String as PropType<BusStopEventCode>,
    required: true,
  },
  busLocations: {
    type: Array as PropType<IBusLocation[]>,
    default: () => [],
  },
  busStop: {
    type: Object as PropType<IBusStop>,
    required: true,
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickBubble", "onClickBusIcon"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "0da62f96-busLocationLeftMarginPx": (_unref(busLocationLeftMarginPx))
}))

const props = __props;

const emit = __emit;

const emitOnClickBubble = () => {
  if (!isMultipleBuses.value) return;

  emit("onClickBubble");
};

const emitOnClickBusIcon = (busesImageExisted: IBus[]) => {
  emit("onClickBusIcon", busesImageExisted);
};

const busLocationLeftMarginPx = props.showInMainCard ? "45px" : "50px";

/** 현재 선택된 버스를 busLocation배열의 가장 앞으로 정렬 및 호차순으로 정렬 */
const sortedBusLocations = computed(() =>
  locateSelectedBusFirst(props.selectedBus)
);

const isMultipleBuses = computed(() => sortedBusLocations.value.length > 1);

/** 사내 셔틀이 아닌 노선이 만석인 경우 */
const isNonInsideShuttleFullSeat = computed(() => {
  if (props.isInsideShuttle) {
    return false;
  }

  if (sortedBusLocations.value.length !== 1) {
    return false;
  }

  const target = sortedBusLocations.value[0];
  if (target.remainingSeatsCount !== 0) {
    return false;
  }

  return true;
});

/** 말풍선 텍스트 */
const bubbleText = computed(() => {
  if (!sortedBusLocations.value.length) return "";

  if (isMultipleBuses.value) {
    return `외 ${sortedBusLocations.value.length - 1}`;
  }

  const targetBusLocation = sortedBusLocations.value[0];

  if (props.isInsideShuttle) {
    // 사내 셔틀인 경우
    return targetBusLocation.boardingCount === -1
      ? ""
      : `${targetBusLocation.boardingCount}명`;
  }

  // 사내 셔틀이 아닌 경우들
  if (targetBusLocation.remainingSeatsCount === -1) {
    return "";
  }

  if (targetBusLocation.remainingSeatsCount === 0) {
    return "만석";
  }

  return `${targetBusLocation.remainingSeatsCount}석`;
});

/** 해당 정류장에 표시될 버스위치 정보만 필터링 후, 현재 선택된 호차를 포함하여 재정렬 */
const locateSelectedBusFirst = (selectedBus?: IBusLocation) => {
  const busLocations = getSortedBusLocations();

  if (!selectedBus) {
    return busLocations;
  }

  const selectedIndex = busLocations.findIndex(
    (bus) => bus.allocUid === selectedBus.allocUid
  );

  if (selectedIndex === -1) {
    return busLocations;
  }

  return [
    busLocations[selectedIndex],
    ...busLocations.slice(0, selectedIndex),
    ...busLocations.slice(selectedIndex + 1),
  ];
};

/** 버스 위치 정보만 필터링 후, 오름차순으로 정렬 */
const getSortedBusLocations = () => {
  const busLocations: IBusLocation[] = [];

  props.busLocations?.forEach((location) => {
    location.busStopEvents.forEach((event) => {
      if (
        event.uid === props.busStop.id &&
        event.busStopEventCode === props.busStopEventCode
      ) {
        busLocations.push(location);
      }
    });
  });

  busLocations.sort((a, b) => a.busOrder - b.busOrder); // 오름차순 정렬
  return busLocations;
};

const __returned__ = { props, emit, emitOnClickBubble, emitOnClickBusIcon, busLocationLeftMarginPx, sortedBusLocations, isMultipleBuses, isNonInsideShuttleFullSeat, bubbleText, locateSelectedBusFirst, getSortedBusLocations, get BusStopEventCode() { return BusStopEventCode }, MultiBusIndicator, BusLocationIndicatorBubble }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})